<template>
  <!-- Top Hero Banner Section -->
  <header class="relative" :class="{ 'mb-8': isSmallScreen && !article.content }">
    <template v-if="mediaImage">
      <!-- desktop -->
      <UiArticleMediaImage v-if="mediaImage" class="hidden md:block" 
      :altText="altText"
      :src="mediaImage.image.url" :title="article.title"
        :overlaytop="false" :overlaybottom="false" :width="Number(1442)" :height="Number(900)"
        :sizes="'md:1024px lg:1280px xl:1535 2xl:2500'" :modifiers="modifiers" />

      <!-- mobile 375x464 -->
      <UiArticleMediaImage v-if="mediaImage" class="block md:hidden" 
      :altText="altText"
      :src="mediaImage.image.url" :title="article.title"
        :overlaytop="false" :overlaybottom="false" :width="Number(375)" :height="Number(464)" :sizes="'412px sm:640px'" :modifiers="modifiers" />
    </template>
    <UiArticleImage v-else :fit="'crop'" :modifiers="modifiers" v-if="article.image" :article="article" />
    <UiContentwrapper class="absolute justify-center items-center inset-0">
      <UiNarrowcolumn>
        <div class="mb-0 items-center mt-16 text-white bannertextshadow" :class="{ 'text-center': isTextCentered }"
          v-html="article.excerpthtml" />
      </UiNarrowcolumn>
    </UiContentwrapper>
  </header>
  <!-- Display the content under the image -->
  <UiExtraNarrowContent v-if="article.content">
    <p class="large mt-16">{{ article.content }}</p>
  </UiExtraNarrowContent>

</template>

<script setup>
import { useBlogStore } from '@/stores/blogStore';
import { computed, ref, onMounted, onUnmounted } from 'vue';

const blogStore = useBlogStore();
const isSmallScreen = ref(false);



// Detect small screen size
const updateScreenSize = () => {
  isSmallScreen.value = window.matchMedia('(max-width: 768px)').matches;
};

onMounted(() => {
  updateScreenSize();
  window.addEventListener('resize', updateScreenSize);
});

onUnmounted(() => {
  window.removeEventListener('resize', updateScreenSize);
});

// Check if the article has the "textcenter" tag
const isTextCentered = computed(() => {
  if (props.article.tags) {
    return blogStore.articleHasTag(props.article, 'textcenter');
  } else {
    return false;
  }
});

const altText = computed(() => {
  return mediaImage.value?.image.altText || props.article.title || 'Gravaa image';
});

// Check if the article has the "Tall" tag and adjust for small screens
const modifiers = computed(() => {
  
  if (isSmallScreen.value) {
    return {
      auto: 'format,compress',
      ar: '16:20', // Aspect ratio for small screens
      'fp-x': mediaImage.value?.presentation?.asJson.focalPoint.x ?? 0.5,
      'fp-y': mediaImage.value?.presentation?.asJson.focalPoint.y ?? 0.5,
    };
  } else if (props.article.tags && blogStore.articleHasTag(props.article, 'Tall')) {
    return {
      auto: 'format,compress',
      ar: '1440:623',
      'fp-x': mediaImage.value?.presentation?.asJson.focalPoint.x ?? 0.5,
      'fp-y': mediaImage.value?.presentation?.asJson.focalPoint.y ?? 0.5,
    };
  } else {
    return {
      auto: 'format,compress',
      ar: '1440:495',
      'fp-x': mediaImage.value?.presentation?.asJson.focalPoint.x ?? 0.5,
      'fp-y': mediaImage.value?.presentation?.asJson.focalPoint.y ?? 0.5,
    };
  }

        
});

// Props
const props = defineProps({
  article: {
    type: Object,
    required: true,
  }
});

const mediaImage = computed(() => props.article.coverImage?.reference || null);
</script>

<style scoped>
@reference "../../assets/css/main.css";
::v-deep(h1) {
  @apply text-7xl;
}

::v-deep(h2) {
  @apply text-5xl;
}


.bannertextshadow {
  @apply drop-shadow-lg
}

/* Adjust font sizes for smaller screens */
@media (max-width: 768px) {

  ::v-deep(h1) {
    @apply text-4xl;
  }

  ::v-deep(h2) {
    @apply text-4xl;
  }
}

@media (max-width: 400px) {
  ::v-deep(h1) {
    @apply text-3xl;
  }

  ::v-deep(h2) {
    @apply text-2xl;
  }

  .mb-8 {
    margin-bottom: 6px !important;
  }

  .mt-16 {
    margin-top: 32px !important;
  }
}
</style>
